import isEqual from 'lodash/isEqual';
import { useRef, useEffect } from 'react';
import { useCompoundComponent } from './useCompoundComponent.mjs';

function noop() {}
function useCompoundComponentLifecycle(type, props) {
  const {
    registerComponent,
    updateComponent,
    unregisterComponent
  } = useCompoundComponent();
  const id = useRef(null);
  const previousProps = useRef(props);
  useEffect(() => {
    if (id.current === null) {
      return;
    }
    if (isEqual(props, previousProps.current)) {
      return;
    }
    previousProps.current = props;
    updateComponent(type, id.current, props);
  });
  useEffect(function registerOnMount() {
    const registeredId = registerComponent(type, props);
    if (!registeredId) {
      return noop;
    }
    id.current = registeredId;
    return function unregisterOnUnmount() {
      unregisterComponent(type, registeredId);
    };
  },
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [type]);
}

export { useCompoundComponentLifecycle };
